import { Orders_Bank_Accounts } from '@/__generated__/graphql';
import { TypedDocumentNode, gql } from '@apollo/client';

export type CompanyBankAccount = Pick<
  Orders_Bank_Accounts,
  | 'aba'
  | 'acct_number'
  | 'bank_account_holder_name'
  | 'bank_address'
  | 'bank_code'
  | 'bank_country'
  | 'bank_name'
  | 'bankgiro_number'
  | 'bic_swift'
  | 'branch_code'
  | 'bsb_code'
  | 'clabe'
  | 'cnaps'
  | 'combination_id'
  | 'currency'
  | 'deactivated_at'
  | 'error_msgs'
  | 'iban'
  | 'ifsc'
  | 'institution_no'
  | 'payment_type'
  | 'plusgiro_number'
  | 'sort_code'
  | 'id'
>;

export type GetCompanyBankAccountByIdQueryType = {
  orders_companies_by_pk: {
    bank_accounts: CompanyBankAccount[];
  };
};

export type GetCompanyBankAccountByIdQueryVariablesType = {
  companyId?: number;
  bankId: number | null;
};
export const getCompanyBankAccountByIdQuery = gql`
  query getCompanyBankAccountByIdQuery($companyId: bigint!, $bankId: bigint) {
    orders_companies_by_pk(id: $companyId) {
      id
      bank_accounts(where: { id: { _eq: $bankId } }) {
        aba
        acct_number
        bank_account_holder_name
        bank_address
        bank_code
        bank_country
        bank_name
        bankgiro_number
        bic_swift
        branch_code
        bsb_code
        clabe
        cnaps
        combination_id
        currency
        deactivated_at
        error_msgs
        iban
        ifsc
        institution_no
        payment_type
        plusgiro_number
        sort_code
        id
      }
    }
  }
` as TypedDocumentNode<
  GetCompanyBankAccountByIdQueryType,
  GetCompanyBankAccountByIdQueryVariablesType
>;
